/**
 * Modules compare
 * ======================================
 * - jquery needed
 */
import $ from "jquery";

$("body").on("click", ".js-modulechange", function(e) {
  const $this = $(this);
  const value = $this.data("value");
  const startValue = $this
    .closest(".module")
    .find(".module-default-progressbar")
    .data("value");
  const $btn = $this.closest(".module").find(".module-compare-name");
  const $progress = $this.closest(".module").find(".module-progressbar");
  const $difference = $this.closest(".module").find(".module-difference");

  const $positive = $this.closest(".module").find(".module-positive");
  const $negative = $this.closest(".module").find(".module-negative");

  const difference = startValue - value;

  $progress.css("width", value + "%");
  $difference.html(difference);
  $btn.html($this.html());

  if (difference > 0) {
    $negative.addClass("d-none");
    $positive.removeClass("d-none");
  } else {
    $negative.removeClass("d-none");
    $positive.addClass("d-none");
  }

  e.preventDefault();
});
